import { render } from "./PdfImageCropped.vue?vue&type=template&id=2008d5b2"
import script from "./PdfImageCropped.vue?vue&type=script&lang=js"
export * from "./PdfImageCropped.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__